import { observable, configure, action, runInAction } from "mobx";
import API from '../server/index';
import Toast from '../component/toast';

configure({enforceActions: 'observed'});

// interface IForm {
//   companyName: string, // 公司名称
//   category: any[], // 主营类目
//   businessLicense: any[], // 营业执照
//   brand: any[], // 品牌授权书
//   other: any[], // 其他资料
//   name: string, // 联系姓名
//   mobile: string, // 联系电话
//   wx: string, // 微信
//   qq: string, // qq
//   email: string // email
// }

const initForm = {
  companyName: '',
  category: [],
  mainBrand: '',
  businessLicense: [],
  brand: [],
  other: [],
  name: '',
  mobile: '',
  managerName: '',
  wx: '',
  qq: '',
  email: ''
};
const initValid = {
  companyName: {
    require: true,
    valid: true,
    reg: /^.{1,50}$/,
    msg: '请输入50字以内的公司名称'
  },
  category: {
    require: true,
    valid: true,
    msg: '请选择主营类目'
  },
  mainBrand: {
    require: true,
    valid: true,
    msg: '请输入主营品牌'
  },
  name: {
    require: true,
    valid: true,
    reg: /^[\u4e00-\u9fa5a-zA-Z\s]{1,30}$/,
    msg: '请输入联系姓名'
  },
  mobile: {
    require: true,
    reg: /^[1]\d{10}$/,
    valid: true,
    msg: '请输入11位的联系电话'
  },
  wx: {
    require: true,
    reg: /^.{1,20}$/,
    valid: true,
    msg: '请输入正确的微信号'
  },
  qq: {
    reg: /^[1-9]\d{4,9}$/,
    valid: true,
    msg: '请输入正确的QQ账号'
  },
  email: {
    reg: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
    valid: true,
    msg: '请输入正确的邮箱账号'
  },
  managerName: {
    valid: true,
    reg: /^[\u4e00-\u9fa5a-zA-Z\s]{1,30}$/,
    msg: '请输入联系姓名'
  },
}

class Step {
  @observable currentStep: number = 1;
  @observable isAgree: boolean = false;
  @observable form: any = {...initForm};
  @observable valid: any = {...initValid};
  @observable canSubmit: boolean = false;
  @observable canNextStep: boolean = false;

  validData(step: number) {
    let result = true;
    if (step === 2) {
      if (!this.valid.companyName.reg.test(this.form.companyName)) {
        this.valid.companyName.valid = false;
        this.valid.companyName.msg = '请输入50字以内的公司名称';
        result = false;
      } else {
        this.valid.companyName.valid = true;
      }
      if (!this.form.mainBrand) {
        this.valid.mainBrand.valid = false;
        result = false;
      } else {
        this.valid.mainBrand.valid = true;
      }
      if (this.form.category.length < 1 || this.form.category.length > 3) {
        this.valid.category.valid = false;
        result = false;
      } else {
        this.valid.category.valid = true;
      }
      if (!this.isAgree) {
        result = false;
        Toast('请阅读并同意遥望平台账号用户协议和隐私政策')
      }
    }
    if (step === 3) {
      ['name', 'mobile', 'wx', 'qq', 'email'].forEach((item => {
        if ((this.valid[item].require && !this.form[item]) || (this.form[item] && !this.valid[item].reg.test(this.form[item]))) {
          this.valid[item].valid = false;
          result = false;
        } else {
          this.valid[item].valid = true;
        }
      }))
    }
    return result;
  }
  // 更改值
  @action.bound
  updateForm(key: string, value: any) {
    this.form = {...this.form, [key]: value};
    if (!['companyName', 'category', 'businessLicense', 'brand', 'other'].includes(key)) {
      let result = true;
      ['name', 'mobile', 'wx', 'qq', 'email', 'managerName'].forEach((item => {
        if ((this.valid[item].require && !this.form[item]) || (this.form[item] && !this.valid[item].reg.test(this.form[item]))) {
          result = false;
        }
      }))
      this.canSubmit = result
    } else if (['companyName', 'category', 'mainBrand'].includes(key)) {
      if (this.isAgree && this.valid.companyName.reg.test(this.form.companyName) && (this.form.category.length < 4 && this.form.category.length > 0)) {
        this.canNextStep = true
      }
    }
  }

  // 更改是否同意协议
  @action.bound
  updateAgreement() {
    this.isAgree = !this.isAgree;
    if (this.isAgree && this.form.mainBrand && this.valid.companyName.reg.test(this.form.companyName) && (this.form.category.length < 4 && this.form.category.length > 0)) {
      this.canNextStep = true
    }
  }

  // 更改步骤
  @action.bound
  async changeStep(step: number) {
    if (this.validData(step)) {
      if (step === 2) {
        const resData = await API.ApiCheckSupplyName11900({ companyName: this.form.companyName });
        if (resData.data.exist === 1) {
          Toast('此公司已申请过商家入驻，请检查公司名称是否填写正确');
          runInAction(() => {
            this.valid.companyName.valid = false;
            this.valid.companyName.msg = '此名称已申请入驻，请检查是否填写正确';
          })
          return;
        }
      }
      if (step === 3) {
        let params = new FormData()
        params.append('companyName', this.form.companyName.trim());
        params.append('mainBrand', this.form.mainBrand);
        params.append('category', this.form.category);
        params.append('name', this.form.name);
        params.append('mobile', this.form.mobile);
        params.append('wx', this.form.wx);
        params.append('qq', this.form.qq);
        params.append('email', this.form.email);
        params.append('managerName', this.form.managerName);
        this.form.businessLicense.forEach((item: any) => {
          params.append('businessLicense', item);
        })
        this.form.brand.forEach((item: any) => {
          params.append('brand', item);
        })
        this.form.other.forEach((item: any) => {
          params.append('other', item);
        })
        // @ts-ignore
        await API.ApiMerchantsSettle11080(params);
      }
      runInAction(() => {
        this.currentStep = step;
      })
    }
  }
  @action.bound
  changeThisStep(step: number) {
    this.currentStep = step;
  }
  @action.bound
  reset() {
    this.currentStep = 1;
    this.form = {...initForm};
    this.valid = {...initValid}
  }
}

export default new Step()